<template>
  <div id="ylInvestStrategy">
    <ylInvestStrategyMobile v-if="isMobileScreen" ref="box-mobile" v-bind="$attrs" :list="list" />
    <ylInvestStrategyPC v-else ref="box-pc" v-bind="$attrs" :list="list" />
  </div>
</template>
<script>
export default {
  name: "ylInvestStrategy",
  components: {
    ylInvestStrategyMobile: () => import("./components/mobile.vue"),
    ylInvestStrategyPC: () => import("./components/pc.vue"),
  },
  data() {
    return {
      list: [],
    }
  },
  computed: {
    screenWidth() {
      return this.$store.getters.screenWidth;
    },
    screenHeight() {
      return this.$store.getters.screenHeight;
    },
    isMobileScreen() {
      return this.$store.getters.isMobileScreen;
    },
  },
  created() {
    this.investmentStrategy()
  },
  methods: {
    async investmentStrategy() {
      let res = await this.$api.investmentStrategy()
      this.list = res
      this.$nextTick(() => {
        this.$refs['box-pc'].$refs.item.forEach((item, index) => {
          item.addEventListener('mouseenter', () => this.$refs['box-pc'].active = index)
        })
      })
    },
  }
};
</script>